// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * @internal
 */
export const packageVersion = "1.5.0";

/**
 * @internal
 */
export const appConfigurationApiVersion = "2023-10-01";
